import { useFetcher } from 'react-router';
import LinkButton from '~/components/button/LinkButton';
import Submit from '~/components/button/Submit';
import Page from '~/components/layout/page/Page';
import LineItem from '~/components/LineItem';
import { useLoaderData } from './shopNowComplete';

export default function ShopNowCompletePage() {
  const { lineItems } = useLoaderData();
  const fetcher = useFetcher();

  return (
    <Page.Root
      title="Your selected items"
      subtitle="Review your selections below before continuing with your return."
    >
      <ul className="flex flex-col gap-4">
        {lineItems.map((item) => (
          <li key={item.gid}>
            <LineItem
              variant="small"
              name={item.title ?? 'N/A'}
              options={item.options ?? []}
              imgSrc={item.imgUrl}
              quantity={item.quantity}
            />
          </li>
        ))}
      </ul>

      <div className="flex flex-col gap-4">
        <LinkButton variant="filled" to="../../address" className="md:w-1/2">
          Continue with Return
        </LinkButton>
        <fetcher.Form
          method="POST" // `?index` is needed to target the index route action (https://reactrouter.com/6.30.1/guides/index-search-param)
          action="../../shop?index"
        >
          <Submit variant="ghost" name="action" value="removeItems">
            Remove items and shop again
          </Submit>
        </fetcher.Form>
      </div>
    </Page.Root>
  );
}
